import React, { useState } from "react";

const ModalComponent = ({
  isOpen,
  onClose,
  complaintDetails,
  title = "Default Title",
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      {isOpen && (
        <div
          className="relative z-100"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div
                      className="mx-auto flex w-[35px] h-[35px] absolute right-2.5 top-2.5 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 cursor-pointer"
                      onClick={onClose}
                    >
                      <svg
                        className="h-6 w-6 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 6l12 12M6 18L18 6"
                        />
                      </svg>
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <h3
                        className="text-base font-semibold leading-6 text-gray-900"
                        id="modal-title"
                      >
                        {title}
                      </h3>

                      <div className="flex flex-wrap mt-4">
                        {complaintDetails.images &&
                        complaintDetails.images.length > 0 ? (
                          complaintDetails.images.map((image, index) => (
                            <div
                              key={index}
                              className="w-1/4 p-2 cursor-pointer"
                              onClick={() => handleImageClick(image)}
                            >
                              <img
                                src={image}
                                alt={`Image ${index + 1}`}
                                className="w-[100px] h-[100px] object-cover rounded-[15px] shadow-md"
                              />
                            </div>
                          ))
                        ) : (
                          <div className="w-full p-4 text-center text-gray-500">
                            No images to show.
                          </div>
                        )}
                      </div>

                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          <b>Vendor Note:</b> {complaintDetails?.description}
                        </p>
                      </div>
                      {complaintDetails?.adminRemarks && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            <b>Remarks:</b> {complaintDetails?.adminRemarks}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="relative w-fit h-full">
            <div
              className="mx-auto flex w-[35px] h-[35px] absolute right-4 top-4 flex-shrink-0 items-center justify-center rounded-full bg-red-100 cursor-pointer"
              onClick={handleCloseImageModal}
            >
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M6 18L18 6"
                />
              </svg>
            </div>
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[100%] max-h-[100%] object-contain cursor-pointer"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ModalComponent;
